import { BaseModel } from './base.model';
import { Tenant } from './tenant.model';

export interface User {
    id: number;
    username: string;
    password?: string;
    email: string;
    createdAt: string;
    consumedtokens: number;
    totaltokens: number;
    tenant?: Tenant;
    issuperadmin?: boolean;
}

export class User implements BaseModel {
    id: number;
    username: string;
    password?: string;
    email: string;
    createdAt: string;
    consumedtokens: number;
    totaltokens: number;
    tenant?: Tenant;
    issuperadmin?: boolean;

    constructor();
    constructor(id: number, username: string, password: string | undefined, email: string, createdAt: string, consumedtokens: number, totaltokens: number, tenant?: Tenant, issuperadmin?: boolean);

    constructor(id?: number, username?: string, password?: string, email?: string, createdAt?: string, consumedtokens?: number, totaltokens?: number, tenant?: Tenant, issuperadmin?: boolean) {
        this.id = id !== undefined ? id : 0;
        this.username = username !== undefined ? username : '';
        this.password = password !== undefined ? password : '';
        this.email = email !== undefined ? email : '';
        this.createdAt = createdAt !== undefined ? createdAt : '';
        this.consumedtokens = consumedtokens !== undefined ? consumedtokens : 0;
        this.totaltokens = totaltokens !== undefined ? totaltokens : 0;
        this.tenant = tenant;
        this.issuperadmin = issuperadmin !== undefined ? issuperadmin : false;
    }

    getApiName(): string { return 'users'; }
    getName(): string { return 'Usuario'; }
    getNamePl(): string { return 'Usuarios'; }
}